import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default function swiperGalleryInit() {
  const galleries = document.querySelectorAll('.gallery-carousel-wrapper');

  galleries.forEach((section) => {
    const gallery = section.querySelector('.js-gallery-carousel');
    if (gallery) {
      const swiper = new Swiper(gallery, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 30,
        breakpoints: {
          480: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          }
        },
        speed: 3000,
        loop: false,
        navigation: true,
        navigation: {
          nextEl: section.querySelector('.carousel-nav-holder .swiper-button-next'),
          prevEl: section.querySelector('.carousel-nav-holder .swiper-button-prev'),
        },
    });
    }
  })
}
